import { render, staticRenderFns } from "./ideology.vue?vue&type=template&id=2b6463da&scoped=true&"
import script from "./ideology.vue?vue&type=script&lang=js&"
export * from "./ideology.vue?vue&type=script&lang=js&"
import style0 from "./ideology.vue?vue&type=style&index=0&id=2b6463da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6463da",
  null
  
)

export default component.exports